import * as t from 'io-ts';

export const SampleTemperatureSchema = t.refinement(t.number, n => n >= 0 && n <= 99, 'SampleTemperature');

export type SampleTemperature = number;
